<template>
  <v-dialog
    v-model="shown"
    max-width="40%"
  >
    <template #activator="{ on }">
      <v-btn
        class="login-btn px-2 py-1"
        color="primary"
        depressed
        small
        v-on="on"
      >
        Log in
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        Log in
      </v-card-title>
      <validation-observer
        v-slot="{ invalid, validated, passes }"
        ref="form"
      >
        <v-form>
          <v-card-text>
            <validation-provider
              v-slot="{ errors }"
              name="email"
              rules="required|email"
            >
              <v-text-field
                v-model="email"
                :error-messages="errors"
                label="e-mail"
                autofocus
                required
              />
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="password"
              rules="required"
            >
              <v-text-field
                v-model="password"
                :error-messages="errors"
                label="password"
                type="password"
                required
              />
            </validation-provider>
            <small>
              <router-link to="/forgot-password">
                Forgot your password?
              </router-link>
            </small>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              text
              @click="passes(login)"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  name: 'LoginButton',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      shown: false,
      email: '',
      password: '',
      notEmpty: [(v) => !!v || 'Field is required'],
    };
  },
  methods: {
    async login() {
      if (!this.$refs.form.validate()) {
        return;
      }
      try {
        await this.$store.dispatch('auth/login', { email: this.email, password: this.password });
      } catch (e) {
        this.$refs.form.setErrors({
          password: 'Invalid email or password',
        });
        return;
      }
      this.$router.push({
        name: 'listScans',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-btn {
  min-width: auto !important;
}
</style>
